import { useQuery } from '@tanstack/react-query';
import { contactUsCategoriesKey, requestContactUsCategories } from './contactUsApi';

/**
 * The active Contact Us categories, in the order the backend returns them. Drives the category
 * dropdown, the cancellation branch, and the per-category success copy — none of which the client
 * hardcodes.
 */
export function useContactUsCategories() {
  return useQuery({
    queryKey: contactUsCategoriesKey,
    queryFn: ({ signal }) => requestContactUsCategories(signal),
  });
}
